import { PropsWithChildren } from 'react'

export function CountdownText({ children }: PropsWithChildren) {
  return <p className="mb-spacing8 tabular-nums text-neutral600">{children}</p>
}
